export default __webpack_public_path__ + "static/go_with_auvelity-e724d29a69f09e7c886bc9a42a91fef6.png";